import { compileContract as compileContractBase } from './compileContract';
import { getSemanticDiagnostics as getSemanticDiagnosticsBase } from './getSemanticDiagnostics';
import { throwOnDiagnosticErrorOrWarning } from './utils';
export const getSemanticDiagnostics = (filePath, languageService, host) => getSemanticDiagnosticsBase({ filePath, languageService, host });
export const compileContract = (filePath, _contractName, host, linked = {}, ignoreWarnings = false) => {
    const result = compileContractBase({ filePath, host, linked });
    throwOnDiagnosticErrorOrWarning(result.diagnostics, ignoreWarnings);
    return result;
};

//# sourceMappingURL=api.js.map
